import React from 'react';
import UserRegisterContent from './user-register-content';

const UserRegister = () => {
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>User</h4>
              </div>
            </div>
            <ul className="table-top-head">
                  <li>
                    <button type="button" className="btn btn-cancel">
                      Cancel
                    </button>
                  </li>
                  <li>
                    <button type="button" className="btn btn-success">
                      Save
                    </button>
                  </li>
                </ul> 
          </div>
          <UserRegisterContent />
        </div>
      </div>
    </div>
  );
};

export default UserRegister;
